import { createSelector } from 'reselect';

export const devToolsSelector = createSelector([
  (store) => store.apps.manual.session,
],
(session) => ({
  device: session.get('device'),
}));

export default {
  devToolsSelector,
};
